export const DEFAULT_COLORS = [
  "#4F46E5",
  "#06B6D4",
  "#10B981",
  "#F59E0B",
  "#EC4899",
  "#8B5CF6",
  "#F97316",
  "#EF4444",
  "#22C55E",
  "#3B82F6",
];


export interface CurrencyTotal {
  currency: string;
  amount: number;
  color: string;
  percentage: number;
}

export interface CurrencyData {
  currency: string;
  amount: number;
}

export interface ProcessedMarketData {
  today: CurrencyData[];
  yesterday: CurrencyData[];
  todayTotal: number;
  yesterdayTotal: number;
  growthAmount: number;
  growthPercent: string;
  isPositiveGrowth: boolean;
}
